<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :width="width"
    :append-to-body="true"
    :destroy-on-close="destroyOnClose"
    @close="handleClose"
    :close-on-click-modal="false"
    class="custom-dialog"
  >
    <!-- 自定义标题栏 -->
    <!-- <template #title>
      <div class="custom-title">
        <icon-title
          :icon-color="'var(--text-color)'"
          :title="title"
          icon="icon-shuxian"
        />
      </div>
    </template> -->
    <!-- 自定义内容插槽 -->
    <slot name="content"></slot>
    <!-- 底部按钮 -->
    <template #footer>
      <div class="dialog-footer">
        <CustomButton
          v-for="button in actionButtons.topButtons"
          :loading="loading"
          :disabled="disabled"
          :isShowList="isShowList"
          :key="button.id"
          :text="button.text"
          :type="button.type"
          :size="button.size"
          :isPlain="button.isPlain"
          :icon="button.icon"
          :hasPermi="button.hasPermi"
          :customStyle="button.customStyle"
          @click="handleClick(button)"
        />
        <!-- <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button> -->
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { actionButtons } from "@/utils/defaultData";
export default {
  props: {
    // 控制弹窗显示/隐藏
    visible: {
      type: Boolean,
      required: true,
      default: false,
    },
    // 是否禁用底部按钮
    disabled: {
      type: Boolean,
      default: false,
    },
    isShowList: {
      type: Array,
      default: () => ["取消", "确定"],
    },
    // 弹窗标题（如“新增被考核对象”）
    title: {
      type: String,
      default: "编辑信息",
    },
    // 弹窗宽度
    width: {
      type: [String, Number],
      default: "50%",
    },
    // 标签宽度
    labelWidth: {
      type: String,
      default: "100px",
    },
    // 关闭时是否销毁表单（避免缓存）
    destroyOnClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      actionButtons: actionButtons,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 按钮点击处理方法
    handleClick(button, row) {
      console.log("点击了按钮", button, row);
      // 可以在这里添加按钮点击逻辑
      if (button.handler) {
        this[button.handler](button, row);
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
      this.resetForm(); // 重置表单
    },
    // 取消按钮
    handleCancelClick() {
      this.handleClose();
      this.$emit("cancel");
    },
    // 确定按钮（表单验证+提交）
    handleConfirmClick() {
      // 验证通过，将表单数据传递给父组件
      this.$emit("confirm");
      //   this.handleClose(); // 提交后关闭弹窗
    },
  },
};
</script>

<style scoped lang="scss">
/* 覆盖element原有样式 */
::v-deep.el-dialog__wrapper {
  .el-dialog {
    border-radius: 20px;
  }
}
.custom-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px 30px;
    max-height: 70vh;
    overflow-y: auto;
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
